export enum CreditorColors {
  DEFAULT = "none",
}
